/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)

import FocusHandler from './Classes/FocusHandler';
import LazyLoad from 'vanilla-lazyload';
import ResponsiveTable from './Classes/ResponsiveTable';
import XDownloader from './Classes/XDownloader';
import xdownloaderConfig from './xdownloader-config';

var focusHandlerInstance = null;
var lazyLoadInstance = null;
var responsiveTableInstance = null;
var downloaderInstance = null;

export default {

  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }

};

// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {


  focusHandlerInstance = new FocusHandler();

  lazyLoadInstance = new LazyLoad();

  responsiveTableInstance = new ResponsiveTable({
    tableSelector: '.ns-table-wrap table',
    tableWrapperSelector: '.ns-table-wrap',
    breakPointLg: 1200,
    breakPointMd: 768,
    breakPointSm: 480,
    colCountNoSplit: 2,
    colCountEarlyBreak: 5,
    noSplitArray: []
  });

  downloaderInstance = new XDownloader(xdownloaderConfig);

  // downloaderInstance = new XDownloader({
  //   downloadText: "XLS", //Can be empty if you want to use an icon instead
  //   backgroundColor: "efeef5", //Colored Cells Background
  //   backgroundClass: 'ns-backgroundcolor-tabellenhg', //Class of colored cells
  //   borderStyle: 'thin', // thin/dotted/medium/double/thick
  //   borderColor2: '312880',
  //   borderStyle2: 'medium',
  //   headClass: 'head', //Class you want your columns based on. Will be bold in Excel
  //   headColor: '312880', //Font Color for the head cells
  //   boldClass: 'bline_bold_space', //Class for Bold text in Excel
  //   boldClass2: 'bline_bold', //Class for Bold text in Excel
  //   borderClass: 'ns-borderbottom-line',
  //   borderClass2: 'ns-borderbottom-bline_blue'
  // });

});
